import { createStyles, makeStyles } from '@material-ui/styles';
import euro from '../../../../assets/3d/MyClassBlock/euro.webp';
import rocket from '../../../../assets/3d/MyClassBlock/rocket.webp';
import bulb from '../../../../assets/3d/MyClassBlock/bulb.webp';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.background.lightblue,
      backgroundPosition: 'bottom -35px right -25px',
      backgroundRepeat: 'no-repeat',
      padding: '20px',
      borderRadius: palette.borderRadius.default,
      color: palette.text.white,
      fontWeight: 500
    },
    text: {
      margin: '0'
    },
    bold: {
      marginTop: '20px',
      fontWeight: 700,
      fontSize: '2rem'
    },
    euro: {
      backgroundImage: `url(${euro})`
    },
    bulb: {
      backgroundImage: `url(${bulb})`,
      alignSelf: 'stretch'
    },
    rocket: {
      backgroundImage: `url(${rocket})`
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
